import { DebuggerManager } from "@/stores/DebuggerManager";
import { XIcon } from "lucide-react";
import { observer } from "mobx-react-lite";

export interface UserDataModalProps {
  manager: DebuggerManager;
  isVisible: boolean;
  onClose?: () => void;
}

export const UserDataModal = observer(({ manager, isVisible, onClose }: UserDataModalProps) => {
  const flattenKeys = (records: Record<string, any>, parentKey = ""): Record<string, any> => {
    const result: Record<string, any> = {};
    for (const key of Object.keys(records)) {
      const value = records[key];
      const newKey = parentKey ? `${parentKey}.${key}` : key;
      if (typeof value === "object" && value !== null) {
        Object.assign(result, flattenKeys(value, newKey));
      } else {
        result[newKey] = value;
      }
    }
    return result;
  };

  const traits = flattenKeys(manager.currentUser?.traits ?? {});

  return (
    <div className={`pyne-debugger-v2__user-data-modal-container ${isVisible ? "visible" : ""}`}>
      <div className="pyne-debugger-v2__user-data-modal-content">
        <div className="pyne-debugger-v2__user-data-modal-header">
          <h2>User data</h2>
          <button className="close-button" onClick={onClose}>
            <XIcon style={{ width: 20, height: 20 }} />
          </button>
        </div>
        <div className="pyne-debugger-v2__user-data-modal-body">
          {!!manager.currentUser && (
            <>
              <div className="pyne-debugger-v2__user-data-modal-content-item">
                <div className="pyne-debugger-v2__user-data-modal-content-item-title">User ID</div>
                <div className="pyne-debugger-v2__user-data-modal-content-item-value">{manager.currentUser?.id}</div>
              </div>
              {Object.keys(traits).map((key) => {
                return (
                  <div className="pyne-debugger-v2__user-data-modal-content-item" key={key}>
                    <div className="pyne-debugger-v2__user-data-modal-content-item-title">{key}</div>
                    <div className="pyne-debugger-v2__user-data-modal-content-item-value">{traits[key]}</div>
                  </div>
                );
              })}
            </>
          )}
          {!manager.currentUser && (
            <div className="pyne-debugger-v2__user-data-modal-content-no-user">No user data available.</div>
          )}
        </div>
      </div>
    </div>
  );
});
